export const accountMenu = {
  roles: {
    collaborator: "Collaborateur",
    hostMode: "Mode hôte",
  },
  header: {
    collaboratorAccess: "Accès collaborateur",
  },
  panel: {
    label: "Vue du panneau",
    apartment: "Appartement",
    hotel: "Hôtel",
  },
  groups: {
    navigate: "Naviguer",
    manage: "Gérer",
  },
  items: {
    home: "Accueil",
    bookings: "Réservations",
    myAccount: "Mon compte",
    myAccommodations: "Mes hébergements",
    aiReception: "Réception IA",
    aiReceptionist: "Réceptionniste IA",
    directBookings: "Réservations directes",
    website: "Site web",
    logout: "Se déconnecter",
  },
  badges: {
    ai: "IA",
    new: "NOUVEAU",
  },
  actions: {
    close: "Fermer",
  },
};
